module.exports = __webpack_public_path__ + "static/media/1.8c31ea91.png";